export default __webpack_public_path__ + "static/media/male@2x.a2648413.png";